webpackJsonp([12],{

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_event_bus_js__ = __webpack_require__(582);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: this.setShow()
    };
  },

  computed: {
    currentStep: function currentStep() {
      return this.$store.getters.step;
    },
    showSignUpSteps: function showSignUpSteps() {
      return this.$store.getters.showStepSignup;
    },
    showOrganizationSteps: function showOrganizationSteps() {
      return this.$store.getters.showStepOrganization;
    },
    isOnline: function isOnline() {
      return this.$store.getters.isOnline;
    },
    showGoBackButton: function showGoBackButton() {
      return !['/dashboard', '/equipments'].includes(this.$route.path);
    }
  },
  methods: {
    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_0__lib_event_bus_js__["a" /* EventBus */].$emit('go-back');
      this.$router.back();
    },
    setShow: function setShow() {
      return this.$router.currentRoute.name !== 'Home';
    }
  },
  watch: {
    '$route': function $route(to, from) {
      to = to.fullPath;
      this.show = true;
      if (['/'].includes(to)) {
        this.show = false;
      }
      if (!['/signUp', '/signUp2'].includes(to)) {
        this.$store.commit('setShowStepSignup', false);
      }
      if (!['/newOrganization'].includes(to)) {
        this.$store.commit('setShowStepOrganization', false);
      }
    }
  }
});

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('v-toolbar', [(_vm.showGoBackButton) ? _c('v-toolbar-side-icon', {
    staticClass: "toolbar-go-back"
  }, [_c('v-icon', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "centered-text"
  }, [_vm._v("Ponce"), (!_vm.isOnline) ? _c('v-icon', {
    staticClass: "toolbar-offline-icon",
    attrs: {
      "color": "#F93A2F"
    }
  }, [_vm._v("cloud_off")]) : _vm._e()], 1), _vm._v(" "), (_vm.showSignUpSteps) ? _c('v-toolbar-items', {
    staticClass: "flex-none"
  }, [_c('b', {
    staticClass: "align-self-center"
  }, [_vm._v("Paso " + _vm._s(_vm.currentStep) + " de 2")])]) : _vm._e(), _vm._v(" "), (_vm.showOrganizationSteps) ? _c('v-toolbar-items', {
    staticClass: "flex-none"
  }, [_c('b', {
    staticClass: "align-self-center"
  }, [_vm._v("Paso 1 de 1")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.39c6bd353ffa8c60ee17.js